import { ArrowRight, ShieldCheck, Sun } from 'lucide-react';
import { Link } from 'react-router-dom';

interface SolarLeadCTAProps {
  source: string;
  title?: string;
  description?: string;
  compact?: boolean;
}

export function SolarLeadCTA({
  source,
  title = 'Compare Verified Solar Installers',
  description = 'Power.ng can help you turn your energy numbers into quotes from Nigerian solar providers for homes, offices, shops, and estates.',
  compact = false,
}: SolarLeadCTAProps) {
  const href = `/solar-quotes?source=${encodeURIComponent(source)}`;

  return (
    <section className={`bg-[#E8F5E9] border border-[#B7E2C8] rounded-xl ${compact ? 'p-5' : 'p-6 md:p-8'} my-8`}>
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-5">
        <div className="flex gap-4">
          <div className="w-12 h-12 rounded-lg bg-[#008751] text-white flex items-center justify-center flex-shrink-0">
            <Sun className="w-6 h-6" />
          </div>
          <div>
            <h2 className={`${compact ? 'text-xl' : 'text-2xl'} font-bold text-gray-900 mb-2`}>{title}</h2>
            <p className="text-gray-700 leading-relaxed">{description}</p>
            <div className="flex items-center gap-2 text-sm text-gray-600 mt-3">
              <ShieldCheck className="w-4 h-4 text-[#008751]" />
              <span>Installer fit, budget, location, and urgency captured in one request.</span>
            </div>
          </div>
        </div>
        <Link
          to={href}
          className="inline-flex items-center justify-center gap-2 bg-[#008751] text-white px-5 py-3 rounded-lg font-bold hover:bg-[#006d41] transition-colors flex-shrink-0"
        >
          Get Solar Quotes
          <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </section>
  );
}
